import type { CustomEditor, CustomElement } from '../types/SlateNodes';

/**
 * Slate plugin that registers `mention` elements as inline + void +
 * markable-void so the editor treats them as a single atom (cursor
 * skips over the inside, backspace removes the whole chip).
 *
 * Other workspace slices already augment Slate's `Element` type via
 * `declare module 'slate'` (TemplateEditor), so we read `.type` via
 * a local cast rather than redeclaring globally.
 */
export function withMentions(editor: CustomEditor): CustomEditor {
  const { isInline, isVoid, markableVoid } = editor;

  editor.isInline = element =>
    (element as CustomElement).type === 'mention' ? true : isInline(element);
  editor.isVoid = element =>
    (element as CustomElement).type === 'mention' ? true : isVoid(element);
  editor.markableVoid = element =>
    (element as CustomElement).type === 'mention' || markableVoid(element);

  return editor;
}
